import React, { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { useI18n } from "../i18n";

export const BeforeAfter = ({ before, after }) => {
  const { t } = useI18n();
  const [pos, setPos] = useState(50);
  const box = useRef(null);

  const move = (clientX) => {
    const r = box.current.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <div className="p-4" data-testid="before-after">
      <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">{t("files.compare")}</p>
      <div
        ref={box}
        onMouseMove={(e) => e.buttons === 1 && move(e.clientX)}
        onMouseDown={(e) => move(e.clientX)}
        onTouchMove={(e) => move(e.touches[0].clientX)}
        className="relative select-none overflow-hidden rounded-xl border border-white/10 bg-[url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20fill%3D%22%23151517%22%2F%3E%3Crect%20x%3D%228%22%20y%3D%228%22%20width%3D%228%22%20height%3D%228%22%20fill%3D%22%23151517%22%2F%3E%3C%2Fsvg%3E')] cursor-ew-resize"
      >
        <img src={after} alt="" className="block max-h-[420px] w-full object-contain" draggable={false} />
        <img
          src={before}
          alt=""
          className="absolute inset-0 block h-full w-full object-contain"
          style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
          draggable={false}
        />

        <div className="pointer-events-none absolute inset-y-0" style={{ left: `${pos}%` }}>
          <div className="h-full w-px bg-sky-400/80 shadow-[0_0_12px_rgba(14,165,233,0.8)]" />
          <div className="absolute top-1/2 -left-4 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full border border-sky-400/60 bg-black/80 backdrop-blur">
            <MoveHorizontal className="h-4 w-4 text-sky-300" strokeWidth={2} />
          </div>
        </div>

        <span className="pointer-events-none absolute left-3 top-3 rounded border border-white/10 bg-black/70 px-2 py-0.5 font-mono2 text-[10px] uppercase tracking-wider text-rose-300">
          {t("files.before")}
        </span>
        <span className="pointer-events-none absolute right-3 top-3 rounded border border-white/10 bg-black/70 px-2 py-0.5 font-mono2 text-[10px] uppercase tracking-wider text-emerald-300">
          {t("files.after")}
        </span>
      </div>
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        data-testid="compare-slider"
        onChange={(e) => setPos(Number(e.target.value))}
        className="mt-3 w-full accent-sky-500"
        aria-label={t("files.compare")}
      />
    </div>
  );
};
